import {TFunction} from "i18next";
import {CustomerTableData} from "../models/CustomerTableData";

/**
 * True when the salesperson of at least one assigned customer could not be resolved
 * (""), so the customer pages warn that the column, and the CSV, is incomplete.
 */
export function hasUnknownSalesperson(items: CustomerTableData[]): boolean {
  return items.some(item => item.salesperson === "")
}

/**
 * Turns the salesperson of each customer row into the text the customer tables show,
 * so the table, the search, the sort and the CSV export all see the same text:
 * the last name, the last name with an inactive marker for a deactivated salesperson,
 * or the unassigned label. "" (salesperson could not be resolved) stays empty. The
 * salespersonDisabled flag is dropped, so the search does not match on it.
 */
export function withSalespersonLabels(items: CustomerTableData[], t: TFunction) {
  return items.map(({salespersonDisabled, ...item}) => ({
    ...item,
    salesperson: item.salesperson === null
      ? t('salesperson.unassigned')
      : salespersonDisabled
        ? t('objects.customer.salespersonInactive', {name: item.salesperson})
        : item.salesperson,
  }))
}
